import React, { Component, Fragment } from 'react';

import defaultUI from '../../data/default.json';
import tcsIAC from '../../data/tcs/tcs-iac.json';
import tcsTR from '../../data/tcs/tcs-tr.json';
import tcsCC from '../../data/tcs/tcs-cc.json';
import tcsDefault from '../../data/tcs/tcs-default.json';
import faqsIAC from '../../data/faqs/faqs-iac';
import faqsTR from '../../data/faqs/faqs-tr';
import faqsCC from '../../data/faqs/faqs-cc';
import faqsDefault from '../../data/faqs/faqs-default.json';
import pp from '../../data/pp/pp';
// import defaultUI from '../../data/iac-default.json';
// import defaultUI from '../../data/iac-sky.json';
// import defaultUI from '../../data/sky.json';


class AppState extends Component {
  constructor(props) {
    super(props);

    this.state = {
      async: {},
      loading: false,
      type: 'default',
      ui: defaultUI,
      route: {
        schema: undefined,
        client: undefined
      },
      settings: {
        culture: 'en-GB',
        csskey: '',
        emailTemplate: ''
      },
      session: {

      },
      cardDetails: {

      },
      code: '',
      eComponentURL: '',
      cardActivation: {
        activeStep: 1,
        status: {
          isVisible: false,
          message: ''
        },
        error: {
          isVisible: false,
          message: ''
        }
      },
      pinRetrieval: {
        activeStep: 1,
        status: {
          isVisible: false,
          message: ''
        },
        error: {
          isVisible: false,
          message: ''
        }
      },
      tcs:{
        iac: tcsIAC,
        tr: tcsTR,
        cc: tcsCC,
        default: tcsDefault
      },
      faqs:{
        iac: faqsIAC,
        tr: faqsTR,
        cc: faqsCC,
        default:faqsDefault
      },
      privacypolicy: pp
    };

    this.setAppState = this.setAppState.bind(this);
    this.validateCodeAndStoreSettings = this.validateCodeAndStoreSettings.bind(this);
    this.validateCodeAndReturnRoute = this.validateCodeAndReturnRoute.bind(this);
    this.setStaticPagesContent =  this.setStaticPagesContent.bind(this);

  }

  componentDidMount() {
    
  }

  setAppState(updater, callback) {
    // newState can be object or function!
    this.setState(updater, () => {
      if (this.props.debug) {
         console.log('setAppState', JSON.stringify(this.state));
      }
      if (callback) {
        callback(this.state);
      }
    });
  }

  validateCodeAndReturnRoute(code, callback) {
    let route = {
      schema: undefined,
      client: undefined
    }
    let ui = code.toLowerCase().split('_');
    
    if (ui[0] === 'default') {
      route.schema = undefined;
      route.client = undefined;
      return route;
    }

    if (ui[1] !== undefined && ui[1].length > 1) {
      route.schema = ui[0];
      route.client = ui[1];
      return route;
    } else {
      route.schema = ui[0];
      route.client = undefined;
      return route;
    }
  }

  validateCodeAndStoreSettings(code, settings, callback) {
    let ui = code.toLowerCase().split('_');
    if (ui[0] === 'default') {
      this.setAppState({
        route: {
          schema: undefined,
          client: undefined
        },
        ui: JSON.parse(settings[0].Value),
        settings: {
          culture: settings[0].CultureCode,
          csskey: settings[1].Value,
          emailTemplate: settings[2].Value
        }
      }, () => {
        if (callback) {
          callback(this.state);
        }
      });
      return;
    }

    if (ui[1] !== undefined && ui[1].length > 1) {
      this.setAppState({
        type: ui[0],
        route: {
          schema: ui[0],
          client: ui[1]
        },
        ui: JSON.parse(settings[0].Value),
        settings: {
          culture: settings[0].CultureCode,
          csskey: settings[1].Value,
          emailTemplate: settings[2].Value
        }
      }, () => {
        if (callback) {
          callback(this.state);
        }
      });
    } else {
      this.setAppState({
        route: {
          schema: ui[0],
          client: undefined
        },
        ui: JSON.parse(settings[0].Value),
        settings: {
          culture: settings[0].CultureCode,
          csskey: settings[1].Value,
          emailTemplate: settings[2].Value
        }
     } , () => {
        if (callback) {
          callback(this.state);
        }
      });
    }
  }

  setStaticPagesContent(settings,callback){
      this.setAppState({
        tcs:{
          iac: JSON.parse(this.getStaticPagesContent(settings, "terms-iac")),
          tr:  JSON.parse(this.getStaticPagesContent(settings, "terms-tr")),
          cc:  JSON.parse(this.getStaticPagesContent(settings, "terms-cc")),
          default:  JSON.parse(this.getStaticPagesContent(settings, "terms-default"))
        },
        faqs:{
          iac: JSON.parse(this.getStaticPagesContent(settings, "faqs-iac")),
          tr:  JSON.parse(this.getStaticPagesContent(settings, "faqs-tr")),
          cc:  JSON.parse(this.getStaticPagesContent(settings, "faqs-cc")),
          default:  JSON.parse(this.getStaticPagesContent(settings, "faqs-default"))
        },
        privacypolicy: JSON.parse(this.getStaticPagesContent(settings, "privacy"))
      }, () => {
        if (callback) {
          callback(this.state);
        }
      })
  }

  getStaticPagesContent(settings, type){
    return settings[(Object.keys(settings).filter(setting => settings[setting].Code === type))[0]].Value;
  }

  render() {
    return (
      <Fragment>
        {React.Children.map(this.props.children, child => {
          return React.cloneElement(child, {
            appState: this.state,
            setAppState: this.setAppState,
            validateCodeAndStoreSettings: this.validateCodeAndStoreSettings,
            validateCodeAndReturnRoute: this.validateCodeAndReturnRoute,
            setStaticPagesContent: this.setStaticPagesContent,
          });
        })}
      </Fragment>
    );
  }
}

export default AppState;



// WEBPACK FOOTER //
// ./src/containers/App/AppState.js